<div class="d-flex flex-column gap-3 h-100">
  @if (documents().length === 0) {
  <div class="border rounded-4 p-4 bg-light text-muted">No generated documents yet.</div>
  } @else { @for (document of documents(); track document.id) {
  <div class="bg-white rounded-4 overflow-hidden mb-3 signable-document-card border position-relative">
    <div
      class="bg-light border-bottom px-3 py-2 d-flex align-items-center justify-content-between w-100 flex-lg-nowrap flex-wrap gap-2"
    >
      <div class="d-flex align-items-center gap-2 flex-fill">
        <div class="d-flex gap-2 align-items-center flex-wrap">
          <div class="d-flex align-items-center gap-2 me-2">
            <div
              class="align-items-center bg-body-secondary d-flex justify-content-center rounded-3 text-primary wh-32"
            >
              <i class="pi pi-file text-dark"></i>
            </div>
            <h5 class="fw-semibold mb-0 text-dark">{{ document.documentType }}</h5>
            @if (document.generatedForLotNo && currentLotNo() && document.generatedForLotNo !== currentLotNo()) {
            <i
              class="bi bi-info-circle text-muted fs-14"
              role="button"
              placement="top"
              container="body"
              [ngbTooltip]="'Generated for lot ' + document.generatedForLotNo + ' (the deal has since moved)'"
            ></i>
            }
          </div>

          <span class="text-grayborder d-none d-md-block">|</span>
          <div class="d-flex align-items-center gap-3 flex-wrap">
            <a
              class="align-items-center d-none d-sm-flex fs-14 gap-1 text-decoration-none fw-500"
              role="button"
              (click)="openPreviewModal(document)"
            >
              <i class="bi bi-eye lh-1"></i>
              View Document
            </a>
            @if (showSignerSection(document)) {
            <span class="text-grayborder d-none d-sm-block">|</span>
            <span class="fs-14 fw-500 text-muted">
              <i class="bi bi-pencil-square me-1"></i>
              {{ signedCount(document) }} of {{ totalSigners(document) }} Signed
            </span>
            }
            <a
              class="align-items-center d-flex d-sm-none fs-14 gap-1 text-decoration-none fw-500 ms-auto"
              role="button"
              (click)="openPreviewModal(document)"
            >
              <i class="bi bi-eye lh-1"></i>
              View
            </a>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end gap-2 ms-auto flex-wrap">
        @if (document.signingType === DealDocumentSignatureFlowType.None) {
        <div class="d-flex align-items-center gap-2 ms-auto">
          @if (showVoidAndRegenerate() && canWriteDeals()) {
          <button class="btn btn-outline-danger btn-h35" (click)="openRegenerateContractConfirmationModal(document)">
            <i class="bi bi-trash"></i>
            Delete
          </button>
          } @if (showEmailFlow()) {
          <button
            class="btn btn-h35 btn-primary text-nowrap"
            (click)="initiateSignatureProcess(document, DealDocumentSignatureFlowType['DocuSign'])"
            [appBtnLoader]="sendViaEmailButtonId(document.id)"
          >
            <i class="bi bi-envelope lh-1"></i>
            Send via Email
          </button>
          } @if (showInPersonFlow()) {
          <button
            role="button"
            class="btn btn-h35 btn-primary text-nowrap"
            (click)="initiateSignatureProcess(document, DealDocumentSignatureFlowType['DocuSignInPerson'])"
            [appBtnLoader]="signNowButtonId(document.id)"
          >
            <i class="bi bi-pen lh-1"></i>
            Sign Now
          </button>
          }
        </div>
        } @else { @if (document.signingType === DealDocumentSignatureFlowType['DocuSignInPerson']) { @if
        (document.status === EnvelopeStatus.Complete) {
        <div
          class="bg-success-subtle text-success-emphasis py-1 px-2 fs-14 rounded-3 fw-500 d-flex align-items-center gap-2 ms-auto"
        >
          <i class="bi bi-check-circle lh-1"></i>All signatures completed
        </div>
        } @else {
        <div
          class="bg-warning-medium text-dark py-1 px-2 fs-14 rounded-5 fw-500 d-flex align-items-center gap-2 ms-auto"
        >
          <i class="bi bi-exclamation-circle lh-1"></i>Awaiting in-person signature
        </div>
        } } @if (document.signingType === DealDocumentSignatureFlowType['DocuSign']) { @if (document.status ===
        EnvelopeStatus.Complete) {
        <div
          class="bg-success-subtle text-success-emphasis py-1 px-2 fs-14 rounded-3 fw-500 d-flex align-items-center gap-2 ms-auto"
        >
          <i class="bi bi-check-circle lh-1"></i>All signatures completed
        </div>
        } @else {
        <div
          class="bg-warning-medium text-dark py-1 px-2 fs-14 rounded-3 fw-500 d-flex align-items-center gap-2 ms-auto"
        >
          <i class="bi bi-exclamation-circle lh-1"></i>Sent for signature via email
        </div>
        } } } @if ( showVoidAndRegenerate() && canWriteDeals() && (document.status === EnvelopeStatus.Sent ||
        document.status === EnvelopeStatus.Expired) ) {
        <button
          class="btn btn-h35 text-nowrap ms-2 btn-outline-danger lh-1"
          (click)="openVoidContractReasonModal(document)"
          [appBtnLoader]="voidContractButtonId(document.id)"
        >
          <i class="pi pi-times-circle"></i>
          Void Contract
        </button>
        }
      </div>
    </div>

    <div class="position-relative pt-2">
      <div
        class="overlay-aps d-flex align-items-center justify-content-center flex-column gap-2"
        [ngClass]="{ 'd-none': !isExpired(document) }"
      >
        <h3 class="text-center text-white mb-1">Expired</h3>
        @if (isExpired(document)) {
        <div class="d-flex flex-column align-items-center">
          @if (!autoResendExhausted(document)) {
          <span class="fs-14 text-white d-inline-flex align-items-center gap-1 mb-2">
            Auto-resend · {{ autoResendRemaining(document) }} attempt{{ autoResendRemaining(document) === 1 ? '' : 's'
            }} remaining
          </span>
          } @else {
          <span class="fs-14 text-white mb-2"
            >Auto-resend limit reached · {{ maxAutoResends }}/{{ maxAutoResends }}</span
          >
          @if (canWriteDeals()) {
          <button
            type="button"
            class="btn btn-h35 btn-light d-flex justify-content-center lh-1 text-nowrap"
            (click)="openResendConfirmationModal(document)"
          >
            <i class="bi bi-arrow-repeat lh-1"></i>Resend
          </button>
          } }
        </div>
        }
      </div>

      @if (showSignerSection(document)) { @for (signature of document.dealDocumentSignatures; track signature.id) {
      <div class="d-flex flex-wrap align-items-center gap-2 px-3 py-2">
        <div class="d-flex align-items-center gap-3 flex-fill">
          <div class="align-items-baseline d-flex flex-column gap-1">
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <h3 class="m-0">{{ signature.signee.name }}</h3>
              <span class="badge bg-info-subtle fw-500 text-info fs-12"> {{ formatSigneeType(signature) }} </span>
            </div>
            @if (signature?.signee?.email) {
            <a
              role="button"
              href="mailto:{{ signature.signee.email }}"
              class="d-flex gap-2 m-0 text-break align-items-baseline fs-14 text-decoration-none"
            >
              <i class="bi bi-envelope"></i>
              {{ signature.signee.email }}
            </a>
            }
          </div>
        </div>

        <div class="d-flex gap-1 align-items-center ms-auto flex-wrap justify-content-end">
          @if (signature.status === RecipientStatus.Complete) {
          <div class="d-flex flex-column gap-1 align-items-end ms-auto">
            <span class="badge bg-success-subtle fw-500 text-success-emphasis fs-12">
              <i class="bi bi-check-circle me-1"></i>
              {{ RecipientStatus.Signed }}
            </span>
            @if (completionSourceLabel(signature)) {
            <span class="fs-12 text-muted">{{ completionSourceLabel(signature) }}</span>
            }
            <span class="fs-12 text-gray-300">
              <i class="bi bi-calendar-check me-1"></i>{{ signature.lastModified | date }}
            </span>
          </div>
          } @else if (isFailedSigner(signature)) {
          <div class="d-flex flex-column gap-1 align-items-end ms-auto">
            <span class="badge bg-danger-subtle fw-500 text-danger">
              <i class="bi bi-exclamation-circle me-1"></i>Delivery failed
            </span>
          </div>
          } @else if (document.signingType === DealDocumentSignatureFlowType['DocuSignInPerson']) { @if
          (isExecutiveSigner(signature)) { @if (allowExecutiveSigning() && signature.status !== RecipientStatus.Pending
          && canWriteDeals()) {
          <button
            type="button"
            class="btn btn-primary btn-h35 fs-12 py-1 h-auto px-2"
            (click)="startInPersonSigning(document, signature)"
            [appBtnLoader]="signNowButtonId(document.id)"
          >
            <i class="bi bi-pen lh-1"></i>Sign Now
          </button>
          } @else if (allowExecutiveSigning()) {
          <span class="fs-12 bg-warning-medium text-dark py-0 px-2 fw-400 ms-auto rounded-5">
            <i class="bi bi-exclamation-circle me-1"></i>Awaiting agent approval
          </span>
          } @else if (!isCoopDocument(document)) {
          <span class="fs-12 bg-info-subtle text-info py-1 px-2 fw-500 ms-auto rounded-5">
            <i class="bi bi-exclamation-circle me-1"></i>Will be taken in Executive Console
          </span>
          } } @else if (showInPersonFlow()) {
          <button
            type="button"
            class="btn btn-primary btn-h35 fs-12 py-1 h-auto px-2"
            (click)="startInPersonSigning(document, signature)"
          >
            <i class="bi bi-pencil-square lh-1"></i>Get Signature
          </button>
          } } @else if (document.signingType === DealDocumentSignatureFlowType['DocuSign']) { @if
          (isExecutiveSigner(signature)) { @if (allowExecutiveSigning() && signature.status !== RecipientStatus.Pending
          && canWriteDeals()) {
          <button
            type="button"
            class="btn btn-primary btn-h35 fs-12 py-1 h-auto px-2"
            (click)="openExecutiveEmailSigning(document, signature)"
          >
            <i class="bi bi-pen lh-1"></i>Sign Now
          </button>
          } @else if (allowExecutiveSigning()) {
          <span class="fs-12 bg-warning-medium text-dark py-0 px-2 fw-400 ms-auto rounded-5">
            <i class="bi bi-exclamation-circle me-1"></i>Awaiting agent approval
          </span>
          } @else if (!isCoopDocument(document)) {
          <span class="fs-12 bg-info-subtle text-info py-1 px-2 fw-500 ms-auto rounded-5">
            <i class="bi bi-envelope me-1"></i>Will be taken in Executive Console
          </span>
          } } } @if (showSendToExecutiveButton(document, signature)) {
          <button
            type="button"
            class="btn btn-primary btn-h35 fs-12 py-1 h-auto px-2"
            (click)="openSendToExecutiveConfirmationModal(document)"
            [appBtnLoader]="sendToExecutiveButtonId(document.id)"
          >
            <i class="bi bi-send lh-1"></i>Send to Executive
          </button>
          } @if (canResolveSignerInDocuSign(document, signature)) {
          <button
            type="button"
            class="btn btn-outline-secondary btn-h35 fs-12 py-1 h-auto px-2"
            (click)="openResolveSignerConfirmationModal(document, signature)"
          >
            <i class="bi bi-envelope-open lh-1"></i>Waive (CC)
          </button>
          }
        </div>
      </div>
      @if (signature.failureReason) {
      <div
        class="align-items-center bg-danger-subtle d-flex gap-2 justify-content-between mb-3 mt-3 mx-3 px-3 py-2 rounded-3 text-danger flex-wrap"
      >
        <span class="align-items-baseline d-flex gap-1">
          <i class="bi bi-exclamation-circle me-1"></i>
          {{ signature.failureReason }}
        </span>
        @if (isFailedSigner(signature) && canWriteDeals()) {
        <button
          type="button"
          class="btn btn-h35 fs-12 h-auto px-2 py-1 text-bg-danger"
          (click)="openResendConfirmationModal(document)"
        >
          <i class="bi bi-arrow-repeat lh-1"></i>Resend
        </button>
        }
      </div>
      } @if (!$last) {
      <hr class="border-secondary-subtle my-2" />
      } } } @if (document.copyRecipients?.length) {
      <div class="border-top px-3 py-2">
        <div class="fs-12 fw-semibold text-muted mb-1"><i class="bi bi-envelope-paper me-1"></i>Receives a copy</div>
        @for (recipient of document.copyRecipients; track recipient.email) {
        <div class="d-flex flex-wrap align-items-center gap-2 py-1">
          <span class="fs-14 fw-500 text-dark">{{ recipient.name }}</span>
          <span class="fs-12 text-muted">{{ recipient.email }}</span>
          <span class="fs-12 bg-body-secondary text-muted py-0 px-2 rounded-5 ms-auto"
            >{{ copyRecipientsStatusText(document) }}</span
          >
        </div>
        }
      </div>
      }
    </div>
  </div>
  } }
</div>

<ng-template #documentPreviewModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header pt-3 pb-0">
      <h2 class="modal-title">{{ selectedPreview()?.name }}</h2>
      <span (click)="modal.dismiss('Cross click')" role="button" class="ms-auto">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body flex-fill min-h-0 overflow-hidden">
      @if (selectedPreview()?.url) {
      <lib-doc-preview [article]="selectedPreview()!.url"></lib-doc-preview>
      } @else {
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-shadow" (click)="modal.dismiss('Close')">Close</button>
    </div>
  </div>
</ng-template>

<ng-template #regenerateContractConfirmationModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header justify-content-between">
      <!-- <h1 class="modal-title">{{ deletable() ? 'Delete' : 'Regenerate' }} Contract</h1> -->
      <h1 class="modal-title">Delete Contract</h1>
      <span (click)="modal.dismiss('Cross click')" role="button">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body p-4 pt-0">
      <p class="mb-0">
        <!-- {{ deletable() ? 'Are you sure you want to delete this contract?' : 'Regenerating the contract will refresh the generated documents.' }} -->
        Are you sure you want to delete this contract?
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-shadow" type="button" (click)="modal.dismiss('Cancel click')">Cancel</button>
      <button class="btn btn-danger" type="button" (click)="modal.close('Confirm regenerate')">
        <!-- {{ deletable() ? 'Delete' : 'Regenerate' }} -->
        Delete
      </button>
    </div>
  </div>
</ng-template>

<ng-template #sendToExecutiveConfirmationModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header justify-content-between">
      <h1 class="modal-title">Send to Executive</h1>
      <span (click)="modal.dismiss('Cross click')" role="button">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body p-4 pt-0">
      <p class="mb-0">This will release the contract to the executive for signing. Continue?</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-shadow" type="button" (click)="modal.dismiss('Cancel click')">Cancel</button>
      <button class="btn btn-primary" type="button" (click)="modal.close('Confirm send to executive')">
        Send to Executive
      </button>
    </div>
  </div>
</ng-template>

<ng-template #resolveSignerConfirmationModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header justify-content-between">
      <h1 class="modal-title">Waive signer (carbon copy)</h1>
      <span (click)="modal.dismiss('Cross click')" role="button">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body p-4 pt-0">
      <p class="mb-0">{{ resolveSignerModalBody() }}</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-shadow" type="button" (click)="modal.dismiss('Cancel click')">Cancel</button>
      <button class="btn btn-primary" type="button" (click)="modal.close('Confirm resolve signer')">
        Waive signer
      </button>
    </div>
  </div>
</ng-template>

<ng-template #resendConfirmationModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header justify-content-between">
      <h1 class="modal-title">Resend Document</h1>
      <span (click)="modal.dismiss('Cross click')" role="button">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body p-4 pt-0">
      <p class="mb-0">This will re-send the document to the recipients who haven't completed it. Continue?</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-shadow" type="button" (click)="modal.dismiss('Cancel click')">Cancel</button>
      <button class="btn btn-primary" type="button" (click)="modal.close('Confirm resend')">Resend</button>
    </div>
  </div>
</ng-template>

<ng-template #voidContractReasonModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header justify-content-between">
      <h1 class="modal-title">Void Contract</h1>
      <span (click)="modal.dismiss('Cross click')" role="button">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>

    <div class="modal-body p-4 pt-0">
      <p class="mb-3">Please provide a reason before voiding this contract.</p>

      <label class="form-label"> Void Reason <span class="text-danger">*</span> </label>

      <generic-dropdown
        placeholder="Select void reason"
        [items]="voidReasonsDropdownItems()"
        [required]="true"
        errormessage="Void reason is required"
        [value]="selectedVoidReasonId()"
        (valueChange)="selectedVoidReasonId.set($event ?? ''); showVoidReasonError.set(false)"
      ></generic-dropdown>

      @if (voidReasonRequiresComment()) {
      <div class="mt-3">
        <label class="form-label" for="voidComment"> Additional comments <span class="text-danger">*</span> </label>
        <textarea
          id="voidComment"
          class="form-control"
          rows="4"
          placeholder="Please describe the reason"
          [value]="voidComment()"
          (input)="voidComment.set($any($event.target).value); showVoidReasonError.set(false)"
        ></textarea>
      </div>
      } @if (showVoidReasonError()) {
      <div class="text-danger mt-1">
        {{ voidReasonRequiresComment() ? 'Comment is required.' : 'Please select a void reason.' }}
      </div>
      }
    </div>

    <div class="modal-footer">
      <button class="btn btn-shadow" type="button" (click)="modal.dismiss('Cancel click')">Cancel</button>
      <button class="btn btn-danger" type="button" (click)="confirmVoidContract(modal, voidComment())">
        Void Contract
      </button>
    </div>
  </div>
</ng-template>
